import { useState } from 'react';
import { getUserAgentMatch } from '../utils/getUserAgentMatch';

export function useIsEmbeddedWebView() {
  // we only need to calculate this once
  const [isEmbedded] = useState(() => {
    return (
      getUserAgentMatch(
        'com.hungryroot.ios.prod|com.hungryroot.android.prod|com.hungryroot.android.staging|com.hungryroot.ios.staging'
      ) ||
      (getUserAgentMatch('Android') && getUserAgentMatch('wv'))
    );
  });
  return isEmbedded;
}
